import React, { Component } from 'react';
import _ from 'lodash';
import '../../assets/styles/tabs.css';

export default class Tabs extends Component {

    onTabChange(tab) {
        this.props.onTabChange(tab);
    }

    renderTabs() {
        return _.map(_.keys(this.props.tabs), (tab) => {
           return (
               <li key={tab} className={this.props.tabs[tab] === this.props.tab ? 'active' : ''}>
                   <a onClick={this.onTabChange.bind(this, this.props.tabs[tab])}>
                       {this.props.tabs[tab]}
                   </a>
               </li>
           )
        });
    }

    render () {
        return (
            <ul className="nav nav-tabs center-aligned" role="tablist">
                {this.renderTabs()}
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/history/tabs.js